import request from "@/plugins/axios/request";

export function queryprovinceandcity(gusetbook) {
    return request({
        url: "/city/queryprovinceandcity",
        method: "post",
        data: gusetbook
    });
}
export function querycaption(ruleForm) {
    return request({
        url: "/basenetdistirctcontroller/querycaption",
        method: "post",
        data: ruleForm
    });
}

export function selecteducationtype(ruleForm) {
    return request({
        url: "/personinfo/selecteducationtype",
        method: "post",
        data: ruleForm
    });
}

export function selectsalarytype(ruleForm) {
    return request({
        url: "/personinfo/selectsalarytype",
        method: "post",
        data: ruleForm
    });
}

export function selectworkStatetype(ruleForm) {
    return request({
        url: "/personinfo/selectworkStatetype",
        method: "post",
        data: ruleForm
    });
}

export function selectschool(ruleForm) {
    return request({
        url: "/universitydict/selectschool",
        method: "post",
        data: ruleForm
    });
}

export function selectmajor(ruleForm) {
    return request({
        url: "/universitymajor/selectmajor",
        method: "post",
        data: ruleForm
    });
}

export function saveresume(ruleForm) {
    return request({
        url: "/onlineController/saveresume",
        method: "post",
        data: ruleForm
    });
}

export function queryosmenucateory(id) {
    return request({
        url: "/osmenucateory/queryosmenucateory",
        method: "post",
        data: { parentId: id }
    });
}

export function selectdictbyvalue(id) {
    return request({
        url: "/personinfo/selectdictbyvalue",
        method: "post",
        data: id
    });
}
//zhuanye
export function selectmajorbyid(id) {
    return request({
        url: "/universitymajor/selectmajorbyid",
        method: "post",
        data: { majorId: id }
    });
}
export function selectschoolbyid(id) {
    return request({
        url: "/universitydict/selectschoolbyid",
        method: "post",
        data: { id: id }
    });
}

export function selectworkage(id) {
    return request({
        url: "/personinfo/selectworkage",
        method: "post",
        data: { id: id }
    });
}

export function saveaffixresume(data) {
    return request({
        url: "/affixresume/saveaffixresume",
        method: "post",
        data: data
    });
}

export function saverecommendresume(data) {
    return request({
        url: "/affixresume/saverecommendresume",
        method: "post",
        data: data
    });
}
